import { Component, ElementRef, HostBinding, OnDestroy, input, model, output, viewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UserRole } from '@navfleet/client/authentication/domain/models';
import { License } from '@navfleet/client/license/domain/models';
import { Permission } from '@navfleet/client/permission/domain/models';
import { Fleet } from '@navfleet/client/shared/models/common';
import { Vessel } from '@navfleet/client/shared/models/vessel';
import { LayoutNotification } from '@navfleet/client/shell/domain/models';
import { Breadcrumb, SideMenuItem } from '@navfleet/client/shell/domain/models';
import { SideMenuComponent } from '@navfleet/client/shell/ui/side-menu';
import { TopMenuComponent } from '@navfleet/client/shell/ui/top-menu';
import { Tenant } from '@navfleet/client/tenant/domain/models';
import { User } from '@navfleet/client/user/domain/models';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
    imports: [TopMenuComponent, SideMenuComponent, RouterOutlet],
    selector: 'fl-layout-ui',
    templateUrl: './layout-ui.component.html',
    styleUrls: ['./layout-ui.component.scss'],
})
export class LayoutUiComponent implements OnDestroy {
    public readonly vessels = input<Vessel[]>([]);
    public readonly isLoadingVessels = input(false);
    public readonly selectedVesselId = model<string | undefined>(undefined);
    public readonly timezone = input<string>();
    public readonly fleets = input<Fleet[]>([]);
    public readonly selectedFleetIds = model<number[]>([]);

    public readonly notifications = input<LayoutNotification[]>([]);
    public readonly filteredOutNotificationCount = input<{ [x: string]: number } | null | undefined>(null);
    public readonly breadcrumbs = input<Breadcrumb[]>([]);

    public readonly isSideMenuMinimized = model<boolean>(false);

    public readonly isFullscreen = input<boolean>(false);

    public readonly user = input<User | undefined>();

    public readonly userRole = input<UserRole | null | undefined>();
    public readonly userCustomRoleName = input<string>();

    public readonly sideMenuItems = input<SideMenuItem[]>([]);

    public readonly licenses = input<License[]>([]);
    public readonly permissions = input<Permission[]>();

    public readonly tenant = input<Tenant>();

    public readonly userCompanyName = input<string | null>();

    public readonly consentClick = output();
    public readonly logoutClick = output();
    public readonly notificationsRead = output();

    @HostBinding('class.is-fullscreen')
    protected get isFullscreenBind() {
        return this.isFullscreen();
    }

    public readonly mainView = viewChild.required<ElementRef<any>>('mainView');

    private endStreams$: Subject<void> = new Subject();

    public dropdownPosition$ = new BehaviorSubject<number>(0);

    ngOnDestroy(): void {
        this.endStreams$.next(null!);
        this.endStreams$.complete();
        this.dropdownPosition$.complete();
    }
}
